import { sortBy } from "lodash";
import { path } from "d3";

export var abs = Math.abs;
export var cos = Math.cos;
export var sin = Math.sin;
export var pi = Math.PI;
export var halfPi = pi / 2;
export var tau = pi * 2;
export var max = Math.max;
export var epsilon = 1e-12;

export function createMatrix(dataArray) {
	const index = new Map(dataArray.map(({ slug }, i) => [slug, i]));
	const matrix = Array.from(index, () => new Array(dataArray.length).fill(0));
	for (let i = 0; i < dataArray.length; i++) {
		const numRelationships = dataArray[i].relationships.length;
		for (let j = 0; j < dataArray[i].relationships.length; j++) {
			matrix[index.get(dataArray[i].slug)][
				index.get(dataArray[i].relationships[j])
			] += 1 / numRelationships;
		}
	}
	return matrix;
}

// set point generator to generate points from angle and radius
export function pointGenerator(angle, radius) {
	const x = radius * Math.sin(angle);
	const y = -radius * Math.cos(angle);
	return { x, y };
}

// convert points to percentage of svg width and height
export function pointAsPercentage({ x, y }, width, height) {
	return {
		x: (x / width) * 100 + "%",
		y: (y / height) * 100 + "%",
	};
}

export function middleAngle(angle1, angle2) {
	return (angle1 + angle2) * 0.5;
}

export function rotateAngle(angle) {
	return (angle * 180) / Math.PI - 90;
}

export function findLastIndex(array, fn) {
	return array.length - 1 - array.slice().reverse().findIndex(fn);
}

export function convertAlphaNumeric(string) {
	return string.replace(/\W/g, "");
}

// makeSorted(toBeSorted: array of strings or objects, fn: function, sortKey: string)
//
// usage with toBeSorted as array of objects (sorted by 'sortKey' = 'key')
// makeSorted(
// 	[
// 		{ key: d.sourceItem.slug, value: d.sourceItem },
// 		{ key: d.targetItem.slug, value: d.targetItem },
// 	],
// 	([a, b]) => [a.value, b.value]
// )
//
// usage with toBeSorted as array of strings:
// makeSorted(
// 	[d.sourceItem.slug, d.targetItem.slug],
// 	([a, b]) => `${a}-${b}`
// )

export function makeSorted(
	toBeSorted,
	fn = (result) => result,
	sortKey = "key"
) {
	return fn(sortBy(toBeSorted, (item) => item[sortKey] ?? item));
}

export function arcGenerator(r, chords, d) {
	let context = path();
	let source = chords.groups.find((el) => el.index === d.source.index);
	let target = chords.groups.find((el) => el.index === d.target.index);
	let sourceAngle = middleAngle(source.startAngle, source.endAngle) - halfPi;
	let targetAngle = middleAngle(target.startAngle, target.endAngle) - halfPi;
	let betweenAngle = middleAngle(sourceAngle, targetAngle);

	let x0 = r * cos(betweenAngle);
	let y0 = r * sin(betweenAngle);
	let x1 = 0;
	let y1 = 0;
	// .2 -> 1 where index is opposite 1 and index is +=1 1
	let diff = Math.abs(source.index - target.index);
	if (diff > chords.groups.length / 2) {
		diff = diff - (diff - chords.groups.length / 2) * 2;
	}
	let per = 0.2 + (diff / (chords.groups.length / 2)) * 0.8;

	let x3 = x0 - (r * per * (x0 - x1)) / r;
	let y3 = y0 - (r * per * (y0 - y1)) / r;
	context.moveTo(r * cos(sourceAngle), r * sin(sourceAngle));
	context.quadraticCurveTo(x3, y3, r * cos(targetAngle), r * sin(targetAngle));
	return "" + context;
}
